import { render, staticRenderFns } from "./RoseApple.vue?vue&type=template&id=89901f26&scoped=true&"
import script from "./RoseApple.vue?vue&type=script&lang=js&"
export * from "./RoseApple.vue?vue&type=script&lang=js&"
import style0 from "./RoseApple.vue?vue&type=style&index=0&id=89901f26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89901f26",
  null
  
)

export default component.exports